import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import Reveal from "./Reveal";
import { IMAGES } from "@/data/content";

const CHAPTERS = [
  {
    no: "01",
    title: "A Celebration of Flavor",
    text: "At Ekaa, every meal is a celebration of flavor, tradition, and hospitality. Located in the heart of Kitchener, we bring together authentic Indian recipes and premium ingredients to craft unforgettable dining experiences.",
  },
  {
    no: "02",
    title: "Crafted with Passion",
    text: "Whether you're here for a family dinner, date night, a celebration, or a casual lunch, our chefs prepare every dish with passion and authenticity — served in an atmosphere of quiet, golden luxury.",
  },
  {
    no: "03",
    title: "From Street Food to Tandoor",
    text: "From flavorful street food to sizzling tandoori specialties and rich, slow-cooked curries, every plate reflects our uncompromising commitment to quality and taste.",
  },
];

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section id="about" data-testid="about-section" className="relative bg-[#0D0D0D] py-24 md:py-36 px-6 md:px-10">
      <div className="mx-auto max-w-[1400px] grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
        <div className="relative">
          <Reveal>
            <p className="text-[#C8A24A] uppercase text-xs tracking-[0.35em] mb-5">Welcome to Ekaa</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-tight">
              Where Flavors <br /> Meet <span className="italic text-gold-gradient">Elegance</span>
            </h2>
          </Reveal>

          <div className="mt-12 space-y-12">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.1} className="flex gap-6 border-l border-[#C8A24A]/25 pl-6">
                <span className="font-display text-3xl text-[#C8A24A]/50 shrink-0">{c.no}</span>
                <div>
                  <h3 className="font-display text-2xl mb-2 text-white">{c.title}</h3>
                  <p className="text-[#D6D6D6] font-light leading-relaxed text-sm md:text-base">{c.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="relative lg:sticky lg:top-28 h-[520px] md:h-[680px] overflow-hidden rounded-sm border border-[#C8A24A]/20">
          <motion.img
            style={{ y: imgY, scale: 1.15 }}
            src={IMAGES.interior}
            alt="Ekaa interior"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] via-transparent to-transparent" />
          <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
            <div>
              <p className="font-display text-2xl text-white">Est. Kitchener</p>
              <p className="text-[#C8A24A] text-xs tracking-[0.25em] uppercase mt-1">Fine Indian Dining</p>
            </div>
            <div className="text-right">
              <p className="font-display text-5xl text-gold-gradient leading-none">2AM</p>
              <p className="text-[#D6D6D6] text-[10px] tracking-[0.2em] uppercase">Late Night</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
